import Vue from 'vue'
import vuescroll from 'vuescroll'

Vue.use(vuescroll, {
  ops: {
    bar: {
      background: '#000',
      opacity: 0.6,
      onlyShowBarOnScroll: false,
      showDelay: 750,
    },
    scrollPanel: {
      speed: 300,
      easing: 'easeInOutQuad',
    },
  },
  name: 'vue-scroll',
})
